import Widget from '@/plugins/dashboard/widgets/Billed/Widget'
import Configure from '@/plugins/dashboard/widgets/Billed/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Billed'
  static widget = Widget
  static configure = Configure
}
